module.exports = __webpack_public_path__ + "static/media/beach.bb9ed34c.svg";